import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-collapse-button',
    templateUrl: './collapse-button.component.html',
    styleUrls: ['./collapse-button.component.scss'],
})
export class CollapseButtonComponent {
    @Input() isActive: boolean;
    
    isLoaded:boolean = false;
    credits = [];

    constructor() {}
}